import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  inject,
} from '@angular/core';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { Position } from 'geojson';
import { isEqual as _isEqual } from 'lodash';
import mapboxgl, { LngLatLike } from 'mapbox-gl';
import { Subject, takeUntil, tap } from 'rxjs';

import { PublicPlaceService } from 'src/app/core/api/services';

import { SmsAggregator } from 'src/app/core/api/models';
import { AppConfigService } from 'src/app/core/services/config.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { CustomPlaceModalComponent } from 'src/app/pages/smart-sms/custom-place/custom-place-modal/custom-place-modal.component';
import { MapPlacesGridService } from '../map-places-grid/map-places-grid.service';
import { PlaceGridLayerData } from '../map-places-grid/place-grid-layer-data.model';
import { CellListComponent } from './cell-list/cell-list.component';
import { PolygonTitleFormComponent } from './polygon-title-form/polygon-title-form.component';

export enum map_color_map {
  'light' = 'light',
  'dark' = 'dark',
}

export class LatLng {
  public lat: number;
  public lng: number;
}

export class SmartSendPolygon {
  public coordinate: string = '';
  public properties: any[] = [];
  getPosition(): Position[][] {
    return JSON.parse(this.coordinate) as Position[][];
  }
  setPosition(value: Position[][]) {
    this.coordinate = JSON.stringify(value);
  }
}

@Component({
    selector: 'smart-send-map-control',
    templateUrl: './smart-send-map-control.html',
    styleUrls: ['./smart-send-map-control.scss'],
    standalone: false
})
export class SmartSendMapControlComponent implements OnInit {
  #mapPlacesGridService = inject(MapPlacesGridService);

  polygonsTitle: any[] = [];
  center: LngLatLike = [51.680374, 32.661343];
  map: mapboxgl.Map = null;
  drawer: MapboxDraw;
  cursorStyle: string = '';
  DisplayPolygonFillColor = '#627BC1';
  DisplayPolygonFillOpacity = 0.5;
  DisplayPolygon: GeoJSON.FeatureCollection<GeoJSON.Polygon> = {
    features: [],
    type: 'FeatureCollection',
  };
  canDrawPolygon: true;
  polygon_to_show: any;
  protected onDestroy$ = new Subject<void>();
  isExpandMap: boolean = true;

  isShowSearchBar: boolean = false;
  isShowSearchPlaces: boolean = false;

  @Input('Theme') Theme: string = map_color_map.light;
  @Input('model') model: any = {};
  @Input('operators') operators: Array<SmsAggregator> = [];
  @Input('MultiPolygon') MultiPolygon: boolean = false;
  @Input('isShowPolygonOptions') isShowPolygonOptions: boolean = true;
  @Input('Zoom') Zoom: number = 9;
  @Output('OnSave') OnSave: EventEmitter<SmartSendPolygon> =
    new EventEmitter<SmartSendPolygon>();
  @Output('OnHelp') OnHelp: EventEmitter<object> = new EventEmitter<object>();
  @Output('OnLoad') OnLoad: EventEmitter<null> = new EventEmitter<null>();
  @Output('OnPublicPlaceClick') OnPublicPlaceClick: EventEmitter<null> =
    new EventEmitter<null>();
  @Input('ShowAddPublicPlace') ShowAddPublicPlace: boolean = false;
  @Input('ShowAddToPublicPlace') ShowAddToPublicPlace: boolean = false;
  @Input('ShowSearchPlace') ShowSearchPlace: boolean = true;
  @Input('ShowSearch') ShowSearch: boolean = true;
  @Input('ShowSaveButton') ShowSaveButton: boolean = true;
  @Input('manualPolygon') manualPolygon: any;
  @Input('removePreviousPolygon') removePreviousPolygon: any;
  @Output('expandMap') output_expandMap: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  styleUrl: string;
  transformReq: any;

  constructor(
    private dialogService: DialogService,
    private publicPlaceService: PublicPlaceService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.getMapStyleUrl();
    // tehran point
    // this.center = [51.3347, 35.7219];
  }

  onPublicPlaceButtonClick() {
    this.OnPublicPlaceClick.emit(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.Theme) this.getMapStyleUrl();
    if (changes.manualPolygon) this.showManualPolygonOnMap();
    if (changes.removePreviousPolygon) this.removeReversePolygonOnMap();
  }

  removeTrailingZeroes(coordinateArray: number[][]): number[][] {
    return coordinateArray.map((coord) => {
      return coord.map((num) => {
        // Convert to string, remove trailing zero and then back to number
        return parseFloat(num.toString());
      });
    });
  }

  removeReversePolygonOnMap() {
    const features = this.drawer.getAll().features;

    let removePolygons = JSON.parse(this.removePreviousPolygon);
    let checkForMultiplePolygons = this.checkMultiplePolygons(removePolygons);
    if (!checkForMultiplePolygons) {
      for (const feature of features) {
        if (
          feature.geometry.type === 'Polygon' &&
          JSON.stringify(feature.geometry.coordinates[0]) ==
            JSON.stringify(
              this.removeTrailingZeroes(JSON.parse(this.removePreviousPolygon))
            )
        ) {
          const featureId = feature.id?.toString(); // Convert to string
          if (featureId) {
            this.drawer.delete(featureId); // Delete using the string ID
          }
          break;
        }
      }
    } else {
      for (const feature of features) {
        for (let index = 0; index < removePolygons.length; index++) {
          if (
            feature.geometry.type === 'Polygon' &&
            JSON.stringify(feature.geometry.coordinates[0]) ==
              JSON.stringify(
                this.removeTrailingZeroes(JSON.parse(removePolygons[index]))
              )
          ) {
            const featureId = feature.id?.toString(); // Convert to string
            if (featureId) {
              this.drawer.delete(featureId); // Delete using the string ID
            }
            break;
          }
        }
      }
    }
  }

  showManualPolygonOnMap() {
    if (this.manualPolygon) {
      let polygons = JSON.parse(this.manualPolygon);
      let checkForMultiplePolygons = this.checkMultiplePolygons(polygons);

      if (checkForMultiplePolygons)
        polygons.forEach((polygon) => {
          this.onAddShowPolygonAutomatically(polygon);
        });
      else this.onAddShowPolygonAutomatically(polygons);
    }
  }

  //چک میکنه که فقط 1 مختصات هست یا بیشتر
  checkMultiplePolygons(polygons: any[]): boolean {
    return polygons.some(
      (polygon) =>
        Array.isArray(polygon) && polygon.some((item) => Array.isArray(item))
    );
  }
  ///<summery>
  ///This method get the map theme color url
  ///</summery>
  getMapStyleUrl() {
    let lightThemeUrl;
    let darkThemeUrl;
    lightThemeUrl = AppConfigService.config.useMapIr
      ? AppConfigService.config.mapIrStyleUrl
      : AppConfigService.config.gisStyleUrl;
    darkThemeUrl = AppConfigService.config.useMapIr
      ? AppConfigService.config.mapIrStyleDarkUrl
      : AppConfigService.config.gisStyleDarkUrl;
    if (this.Theme == map_color_map.light) {
      this.styleUrl = lightThemeUrl;
    } else if (this.Theme == map_color_map.dark) this.styleUrl = darkThemeUrl;
    ConsoleService.info('this.styleUrl', this.styleUrl);
  }

  getSelectedFilterPlace(place: any) {
    if (place.type == 'Area') {
      this.onAddShowPolygonAutomatically(place?.coordinates[0]);
    } else {
      let latLng: LatLng = {
        lat: place.latitude,
        lng: place.longitude,
      };

      //gets previous marker is exists
      let marker = document.getElementsByClassName('marker');

      //checks if marker exists already: if exists : removes previous marker
      if (marker.length > 0) {
        while (marker.length > 0) {
          marker[0].parentNode.removeChild(marker[0]);
        }
      }
      // Add markers to the map.
      const el = this.renderer.createElement('div');
      this.renderer.setProperty(el, 'title', place.title);
      this.renderer.setProperty(el, 'className', 'marker');
      this.renderer.setStyle(
        el,
        'background',
        'url(/assets/media/svg/location-marker.svg)'
      );
      this.renderer.setStyle(el, 'width', '40px');
      this.renderer.setStyle(el, 'height', '40px');
      this.renderer.setStyle(el, 'backgroundSize', '100%');
      new mapboxgl.Marker(el).setLngLat(latLng).addTo(this.map);

      // //set zoom
      const target = {
        center: latLng,
        zoom: 17,
        bearing: 0,
        pitch: 0,
      };

      //fly to selected location
      this.map.flyTo({
        ...target,
        duration: 2500,
        essential: true,
      });
    }
  }

  transformRequest(url: string, resourceType: any) {
    if (AppConfigService.config.useMapIr)
      // use for map.ir
      this.transformReq = {
        url: url,
        headers: {
          'x-api-key': AppConfigService.config.mapIrXApiKey,
        },
      };
    // use for gis
    else
      this.transformReq = {
        url: url,
        headers: {
          Accept:
            'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8',
          Origin: 'http://localhost:4200',
          'Access-Control-Request-Headers': 'access-control-allow-origin',
          'Access-Control-Request-Method': 'GET',
        },
      };
  }

  public SetCenter(center: LngLatLike) {
    this.center = center;
  }

  onMapReady($event) {
    this.map = $event;

    const draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: true,
        trash: true,
      },
      styles: [
        // ACTIVE (being drawn)
        // line stroke
        {
          id: 'gl-draw-line',
          type: 'line',
          filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['!=', 'mode', 'static'],
          ],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#D20C0C',
            'line-dasharray': [0.2, 2],
            'line-width': 2,
          },
        },
        // polygon fill
        {
          id: 'gl-draw-polygon-fill',
          type: 'fill',
          filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
          paint: {
            'fill-color': '#D20C0C',
            'fill-outline-color': '#D20C0C',
            'fill-opacity': 0.1,
          },
        },
        // polygon mid points
        {
          id: 'gl-draw-polygon-midpoint',
          type: 'circle',
          filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
          paint: {
            'circle-radius': 5,
            'circle-color': '#fb3b3b',
          },
        },
        // polygon outline stroke
        // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
        {
          id: 'gl-draw-polygon-stroke-active',
          type: 'line',
          filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#D20C0C',
            'line-dasharray': [0.2, 2],
            'line-width': 1,
          },
        },
        // vertex point halos
        {
          id: 'gl-draw-polygon-and-line-vertex-halo-active',
          type: 'circle',
          filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['!=', 'mode', 'static'],
          ],
          paint: {
            'circle-radius': 7,
            'circle-color': '#FFF',
          },
        },
        // vertex points
        {
          id: 'gl-draw-polygon-and-line-vertex-active',
          type: 'circle',
          filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['!=', 'mode', 'static'],
          ],
          paint: {
            'circle-radius': 5,
            'circle-color': '#D20C0C',
          },
        },

        // INACTIVE (static, already drawn)
        // line stroke
        {
          id: 'gl-draw-line-static',
          type: 'line',
          filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['==', 'mode', 'static'],
          ],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#000',
            'line-width': 3,
          },
        },
        // polygon fill
        {
          id: 'gl-draw-polygon-fill-static',
          type: 'fill',
          filter: ['all', ['==', '$type', 'Polygon'], ['==', 'mode', 'static']],
          paint: {
            'fill-color': '#000',
            'fill-outline-color': '#000',
            'fill-opacity': 0.1,
          },
        },
        // polygon outline
        {
          id: 'gl-draw-polygon-stroke-static',
          type: 'line',
          filter: ['all', ['==', '$type', 'Polygon'], ['==', 'mode', 'static']],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#000',
            'line-width': 2,
          },
        },
      ],
    });
    this.map.addControl(draw);
    this.drawer = draw;

    this.OnLoad.emit(null);
    this.map.on('draw.modechange', (e) => {
      const data = draw.getAll();
      if (draw.getMode() == 'draw_polygon') {
        let pids: any[] = [];

        // ID of the added template empty feature
        const lid = data.features[data.features.length - 1].id;
        data.features.forEach((f) => {
          if (f.geometry.type === 'Polygon' && f.id !== lid) {
            pids.push(f.id);
          }
        });
        if (!this.MultiPolygon) draw.delete(pids);
      }
    });
    this.map.on('draw.delete', (e) => {
      let showTitleBtns = document.querySelectorAll('.show-title');
      let showTitleFromModelBtns = document.querySelectorAll(
        '.show-title-from-model'
      );
      let addTitleBtns = document.querySelectorAll('.addBtn');
      let cellListBtn = document.querySelectorAll('.cellListBtn');
      addTitleBtns.forEach((box) => {
        box.remove();
      });
      showTitleBtns.forEach((box) => {
        box.remove();
      });
      showTitleFromModelBtns.forEach((box) => {
        box.remove();
      });
      cellListBtn.forEach((box) => {
        box.remove();
      });
    });
    this.map.on('draw.selectionchange', (e) => {
      this.setMarker(e);
    });
    this.ShowPolygon(this.polygon_to_show);
  }

  onSaveButtonClick($event) {
    let data = this.drawer.getAll();
    let jsonPoints: Position[][] = [];
    data.features.forEach((f) => {
      if (f.geometry.type == 'Polygon') {
        jsonPoints = f.geometry.coordinates;
      }
    });
    var item = new SmartSendPolygon();
    item.setPosition(jsonPoints);

    this.OnSave.emit(item);
  }

  public getDrawedPolygon(): Position[][] {
    let data = this.drawer.getAll();
    let jsonPoints: Position[][] = [];
    data.features.forEach((f) => {
      if (f.geometry.type == 'Polygon') {
        jsonPoints = f.geometry.coordinates;
      }
    });
    return jsonPoints;
  }

  public getAllPolygons(): Array<Position[][]> {
    let pols = [];
    let data = this.drawer.getAll();
    let jsonPoints: Position[][] = [];
    data.features.forEach((f) => {
      if (f.geometry.type == 'Polygon') {
        jsonPoints = f.geometry.coordinates;
        pols.push(jsonPoints);
      }
    });
    this.DisplayPolygon.features.forEach((item) => {
      pols.push(item.geometry.coordinates);
    });
    ConsoleService.info('pols', pols);
    return pols;
  }

  public removePolygon() {
    this.DisplayPolygon.features = [];
    (this.map.getSource('polygon-source') as mapboxgl.GeoJSONSource).setData(
      this.DisplayPolygon
    );
  }

  getAllPolygonTitles() {
    return this.polygonsTitle;
  }

  public AddDisplayPolygons(polygon_id: string, polygons: any[]) {
    if (this.map == null) {
      return false;
    }
    if (
      this.DisplayPolygon.features.length == 1 &&
      this.DisplayPolygon.features[0].id == 'display-polygon'
    )
      this.DisplayPolygon.features = [];
    if (polygons.length <= 0) {
      return;
    }
    const bounds = new mapboxgl.LngLatBounds(
      polygons[0][0][0],
      polygons[0][0][0]
    );
    polygons.forEach((polygon) => {
      this.DisplayPolygon.features.push({
        type: 'Feature',
        id: polygon_id.toString(),
        geometry: {
          coordinates: polygon,
          type: 'Polygon',
        },
        properties: [],
      });
      // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
      for (const coord of polygon[0]) {
        bounds.extend(coord);
      }
    });

    (this.map.getSource('polygon-source') as mapboxgl.GeoJSONSource).setData(
      this.DisplayPolygon
    );

    this.map.fitBounds(bounds, {
      padding: 20,
    });
  }

  isCoordinateInFeatures(selectedCoordinate: number[][]): boolean {
    return this.DisplayPolygon.features.some((feature) => {
      // Ensure the feature has coordinates and is a Polygon
      if (feature.geometry.type === 'Polygon') {
        return feature.geometry.coordinates.some((polygonCoordinates) => {
          // Compare each polygon's coordinates
          return (
            JSON.stringify(polygonCoordinates) ===
            JSON.stringify(selectedCoordinate)
          );
        });
      }
      return false;
    });
  }

  public AddDisplayPolygon(polygon_id: string, polygon: any, title?: string) {
    if (this.map == null) {
      return false;
    }

    if (this.isCoordinateInFeatures(polygon[0])) return;

    if (title) this.onShowTitle(polygon, title);
    if (
      this.DisplayPolygon.features.length == 1 &&
      this.DisplayPolygon.features[0].id == 'display-polygon'
    )
      this.DisplayPolygon.features = [];
    this.DisplayPolygon.features.push({
      type: 'Feature',
      id: polygon_id.toString(),
      geometry: {
        coordinates: polygon,
        type: 'Polygon',
      },
      properties: [],
    });
    (this.map.getSource('polygon-source') as mapboxgl.GeoJSONSource).setData(
      this.DisplayPolygon
    );
    //
    const bounds = new mapboxgl.LngLatBounds(polygon[0][0], polygon[0][0]);

    // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
    for (const coord of polygon[0]) {
      bounds.extend(coord);
    }

    this.map.fitBounds(bounds, {
      padding: 20,
    });
  }

  removeSelectedPolygon(polygon) {
    this.DisplayPolygon.features = this.DisplayPolygon.features.filter(
      (feature) =>
        feature.geometry.coordinates[0].toString() !== polygon.toString()
    );

    // Update the map source
    (this.map.getSource('polygon-source') as mapboxgl.GeoJSONSource).setData(
      this.DisplayPolygon
    );
  }

  public ShowPolygon(polygon: any) {
    if (polygon == null) return;
    if (this.map == null) {
      this.polygon_to_show = polygon;
      return;
    }
    this.DisplayPolygon.features = [
      {
        type: 'Feature',
        id: 'display-polygon',
        geometry: {
          coordinates: polygon,
          type: 'Polygon',
        },
        properties: [],
      },
    ];
    ConsoleService.info('this.DisplayPolygon', this.DisplayPolygon);

    (this.map.getSource('polygon-source') as mapboxgl.GeoJSONSource).setData(
      this.DisplayPolygon
    );
    const bounds = new mapboxgl.LngLatBounds(polygon[0][0], polygon[0][0]);

    // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
    for (const coord of polygon[0]) {
      bounds.extend(coord);
    }

    this.map.fitBounds(bounds, {
      padding: 20,
    });
  }

  public setDisplayPolygonFill(color: string, opacity: number) {
    this.DisplayPolygonFillColor = color;
    this.DisplayPolygonFillOpacity = 0.5;
  }

  onHelpButtonClick($event) {
    this.OnHelp.emit($event);
  }

  public setEditablePolygon(input: any) {
    this.DisplayPolygon.features = [];
    //now most put the polygon to feature of editable area

    let data = this.drawer?.getAll();
    let jsonPoints: Position[][] = [];
    data.features = [
      {
        type: 'Feature',
        id: 'display-polygon',
        geometry: {
          coordinates: input,
          type: 'Polygon',
        },
        properties: [],
      },
    ];
    this.drawer.set(data);
    const bounds = new mapboxgl.LngLatBounds(input[0][0], input[0][0]);

    // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
    for (const coord of input[0]) {
      bounds.extend(coord);
    }

    this.map.fitBounds(bounds, {
      padding: 20,
    });
  }

  onAddTitleBtn(event) {
    let addBtnElements = document.getElementsByClassName('addBtn');

    this.removeAllPolygonBtns(addBtnElements);

    //creates marker
    const addBtn = this.renderer.createElement('div');
    this.renderer.setProperty(addBtn, 'className', 'addBtn');
    this.renderer.setStyle(
      addBtn,
      'background',
      'url(/assets/media/svg/icons/add-square-purple.svg)'
    );
    this.renderer.setStyle(addBtn, 'width', '27px');
    this.renderer.setStyle(addBtn, 'height', '27px');
    this.renderer.setStyle(addBtn, 'backgroundSize', '100%');
    this.renderer.listen(addBtn, 'click', (e) => {
      this.openPolygonTitleModal(event);
    });
    // Add markers to the map.
    if (event?.features[0]?.geometry?.coordinates[0][0]) {
      new mapboxgl.Marker(addBtn)
        ?.setLngLat(event?.features[0]?.geometry?.coordinates[0][0])
        .addTo(this.map);
    }
  }

  onCellListBtn(event) {
    let cellListBtnElements = document.getElementsByClassName('cellListBtn');
    this.removeAllPolygonBtns(cellListBtnElements);
    //creates marker
    const cellListBtn = this.renderer.createElement('div');
    this.renderer.setProperty(cellListBtn, 'className', 'cellListBtn');
    this.renderer.setStyle(
      cellListBtn,
      'background',
      'url(/assets/media/svg/icons/magnifier-search-zoom.svg)'
    );
    this.renderer.setStyle(cellListBtn, 'width', '27px');
    this.renderer.setStyle(cellListBtn, 'height', '27px');
    this.renderer.setStyle(cellListBtn, 'backgroundSize', '100%');
    this.renderer.listen(cellListBtn, 'click', (e) => {
      this.openShowCellListModal(event);
    });
    // Add markers to the map.
    if (event?.features[0]?.geometry?.coordinates[0][1]) {
      new mapboxgl.Marker(cellListBtn)
        ?.setLngLat(event?.features[0]?.geometry?.coordinates[0][1])
        .addTo(this.map);
    }
  }

  removeAllPolygonBtns(elements) {
    //checks if marker exists already: if exists : removes previous marker
    if (elements.length > 0) {
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }
    }
  }

  setStylesForShowTitleElement(showTitleElement) {
    this.renderer.setStyle(showTitleElement, 'background', '#6372C1');
    this.renderer.setStyle(showTitleElement, 'font-size', '12px');
    this.renderer.setStyle(showTitleElement, 'border-radius', '5px');
    this.renderer.setStyle(showTitleElement, 'overflow', 'hidden');
    this.renderer.setStyle(showTitleElement, 'display', '-webkit-box');
    this.renderer.setStyle(showTitleElement, '-webkit-line-clamp', '1');
    this.renderer.setStyle(showTitleElement, '-webkit-box-orient', 'vertical');
    this.renderer.setStyle(showTitleElement, 'max-width', '150px');
    this.renderer.setStyle(showTitleElement, 'padding', '18px 7px 4px 7px');
    this.renderer.setStyle(showTitleElement, 'font-family', 'Vazirmatn');
    this.renderer.setStyle(showTitleElement, 'color', '#fff');
  }

  addShowTitleToMap(llb, showTitleElement) {
    let center = llb.getCenter();

    new mapboxgl.Marker(showTitleElement)?.setLngLat(center).addTo(this.map);
  }

  onShowTitle(coordinates, title?) {
    if (this.model?.polygons?.length > 0) {
      this.polygonsTitle = this.polygonsTitle.concat(this.model?.polygons);

      this.polygonsTitle = this.polygonsTitle.filter(
        (value, index, self) =>
          index ===
          self.findIndex((obj) => obj.coordinates === value.coordinates)
      );
      let polygonObjectFromModel = this.model.polygons.find((item) =>
        _isEqual(item.coordinates, coordinates)
      );

      if (polygonObjectFromModel) {
        let addBtnElements = document.getElementsByClassName('addBtn');
        this.removeAllPolygonBtns(addBtnElements);
      }

      let showTitle = document.getElementsByClassName('show-title-from-model');
      //checks if marker exists already: if exists : removes previous marker
      if (showTitle.length > 0) {
        while (showTitle.length > 0) {
          showTitle[0].parentNode.removeChild(showTitle[0]);
        }
      }

      const showTitleElement = this.renderer.createElement('div');
      this.renderer.setProperty(
        showTitleElement,
        'className',
        'show-title-from-model'
      );
      this.renderer.setProperty(
        showTitleElement,
        'title',
        title ?? polygonObjectFromModel?.title
      );
      this.renderer.setProperty(
        showTitleElement,
        'innerHTML',
        title ?? polygonObjectFromModel?.title
      );
      this.setStylesForShowTitleElement(showTitleElement);

      if (polygonObjectFromModel?.coordinates[1]) {
        const llb = new mapboxgl.LngLatBounds(
          polygonObjectFromModel?.coordinates[0],
          polygonObjectFromModel?.coordinates[1]
        );
        this.addShowTitleToMap(llb, showTitleElement);
      }
    }
    let polygonObject = this.polygonsTitle.find((item) =>
      _isEqual(item.coordinates, coordinates)
    );

    if (polygonObject) {
      let addBtnElements = document.getElementsByClassName('addBtn');
      this.removeAllPolygonBtns(addBtnElements);
    }

    // let showTitle = document.getElementsByClassName('show-title');
    // //checks if marker exists already: if exists : removes previous marker
    // if (showTitle.length > 0) {
    //   while (showTitle.length > 0) {
    //     showTitle[0].parentNode.removeChild(showTitle[0]);
    //   }
    // }

    const showTitleElement = this.renderer.createElement('div');
    this.renderer.setProperty(showTitleElement, 'className', 'show-title');
    this.renderer.setProperty(
      showTitleElement,
      'title',
      title ?? polygonObject?.title
    );
    this.renderer.setProperty(
      showTitleElement,
      'innerHTML',
      title ?? polygonObject?.title
    );
    this.renderer.setProperty(
      showTitleElement,
      'id',
      coordinates.toString() ?? polygonObject?.coordinates.toString()
    );
    this.setStylesForShowTitleElement(showTitleElement);

    // Create a close button
    const closeButton = this.renderer.createElement('button');
    const closeButtonText = this.renderer.createText('X');
    this.renderer.appendChild(closeButton, closeButtonText);

    // Add styles to the close button
    this.renderer.setStyle(closeButton, 'position', 'absolute');
    this.renderer.setStyle(closeButton, 'top', '5px');
    this.renderer.setStyle(closeButton, 'right', '5px');
    this.renderer.setStyle(closeButton, 'cursor', 'pointer');
    this.renderer.setStyle(closeButton, 'color', 'red');

    // Append the close button to the div
    this.renderer.appendChild(showTitleElement, closeButton);
    this.renderer.listen(closeButton, 'click', () =>
      this.closeShowTitleBtn(
        coordinates.toString() ?? polygonObject.coordinates.toString()
      )
    );

    if (!title) {
      if (polygonObject?.coordinates[1]) {
        const llb = new mapboxgl.LngLatBounds(
          polygonObject?.coordinates[0],
          polygonObject?.coordinates[1]
        );
        this.addShowTitleToMap(llb, showTitleElement);
      }
    } else if (coordinates[0][1]) {
      const llb = new mapboxgl.LngLatBounds(
        coordinates[0][0],
        coordinates[0][1]
      );
      this.addShowTitleToMap(llb, showTitleElement);
    }
  }

  //todo add codes
  closeShowTitleBtn(coordinates) {
    let selectedElement = document.getElementById(coordinates);
    this.renderer.removeChild(selectedElement.parentNode, selectedElement);
  }

  setMarker(event: any) {
    //for set btn
    if (this.isShowPolygonOptions) {
      this.onAddTitleBtn(event);
      this.onCellListBtn(event);
      this.onShowTitle(event?.features[0]?.geometry?.coordinates[0]);
    }
  }

  openPolygonTitleModal(event) {
    this.unSubs();

    const modalResult = this.dialogService.openModal({
      component: PolygonTitleFormComponent,
      // data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res.isSuccess) {
          let polygonTitle = {
            coordinates: event?.features[0]?.geometry.coordinates[0],
            title: res.title,
          };
          this.polygonsTitle.push(polygonTitle);
        }
      });
  }

  openShowCellListModal(event) {
    this.unSubs();
    if (this.operators.length > 0) {
      const modalResult = this.dialogService.openModal({
        component: CellListComponent,
        width: '600px',
        data: {
          operators: this.operators,
          polygon: event?.features[0]?.geometry?.coordinates[0],
        },
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res.isSuccess) {
            let polygonTitle = {
              coordinates: event?.features[0]?.geometry.coordinates[0],
              title: res.title,
            };
            this.polygonsTitle.push(polygonTitle);
          }
        });
    } else {
      this.dialogService.openDialog({
        message: 'pages.createSmartSmsRequest.errors.mustSelectOperator',
        status: DialogStatus.error,
      });
    }
  }

  onAddToPublicPlaceButtonClick() {
    let selectedPolygon: any = this.drawer.getSelected();
    if (selectedPolygon?.features.length > 0) {
      let polygon = selectedPolygon?.features[0]?.geometry.coordinates[0];

      const modalResult = this.dialogService.openModal({
        component: CustomPlaceModalComponent,
        data: {
          showAddToPublicPlace: this.ShowAddToPublicPlace,
          polygon: polygon,
          polygonTitles: this.polygonsTitle,
        },
      });
      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe();
    } else {
      let errMsg = 'messages.selectPolygon';
      this.dialogService.openDialog({
        message: errMsg,
        status: DialogStatus.error,
      });
    }
  }

  //#region selected place
  getSelectedPlace(places: PlaceGridLayerData[]) {
    ConsoleService.info('Places', places);
    //gets previous marker is exists
    let selectedPlace = document.getElementsByClassName('selectedPlace');

    //checks if marker exists already: if exists : removes previous marker
    if (selectedPlace.length > 0) {
      while (selectedPlace.length > 0) {
        if (selectedPlace[0].parentNode) {
          selectedPlace[0].parentNode.removeChild(selectedPlace[0]);
        }
      }
    }

    places.forEach((item) => {
      let latLng: LatLng = {
        lat: item.centroid?.coordinates ? item.centroid.coordinates[1] as any : 0,
        lng: item.centroid?.coordinates ? item.centroid.coordinates[0] as any : 0,
      };

      // Add markers to the map.
      const el = this.renderer.createElement('div');
      this.renderer.setProperty(el, 'title', item.name);
      this.setMarkerBackground(el, item);
      this.renderer.setStyle(el, 'width', '40px');
      this.renderer.setStyle(el, 'height', '40px');
      this.renderer.setStyle(el, 'backgroundSize', '100%');
      new mapboxgl.Marker(el).setLngLat(latLng).addTo(this.map);
      // Create a polygon with a 10 km radius around the point
      const radius = 1; // 1 km
      const circlePolygon = this.getPolygonVertices(
        item.centroid?.coordinates as any,
        radius
      );
      this.renderer.listen(el, 'click', (e) => {
        this.onAddShowPolygonAutomatically(circlePolygon);
      });
    });
  }

  //backgrounds
  setMarkerBackground(el, item: PlaceGridLayerData) {
    let mdiIcon = this.#mapPlacesGridService.getLayerIcon(item.id);

    this.renderer.setProperty(
      el,
      'className',
      `selectedPlace ignore-dark-color mdi tw-text-[30px] tw-align-middle tw-pb-1  ${mdiIcon}`
    );
  }

  public onAddShowPolygonAutomatically(polygon: any) {
    // this.DisplayPolygon.features = [];
    //now most put the polygon to feature of editable area
    let data = this.drawer?.getAll();
    data.features.push({
      type: 'Feature',
      id: String(polygon),
      geometry: {
        coordinates: [polygon],
        type: 'Polygon',
      },
      properties: [],
    });
    this.drawer.set(data);
    const bounds = new mapboxgl.LngLatBounds(polygon[0], polygon[0]);

    // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
    for (const coord of polygon) {
      bounds.extend(coord);
    }

    this.map.fitBounds(bounds, {
      padding: 20,
    });
  }

  // Function to calculate vertices of the polygon
  getPolygonVertices(center: number[], radius: number): number[][] {
    const numSegments = 4; // Number of segments to approximate the circle
    const vertices = [];
    const [lng, lat] = center;

    for (let i = 0; i < numSegments; i++) {
      const angle = (i / numSegments) * Math.PI * 2; // Angle around the circle

      const vertexLng = lng + Math.cos(angle) * (radius / 111.32); // Convert degrees to km
      const vertexLat = lat + Math.sin(angle) * (radius / 111.32); // Convert degrees to km

      vertices.push([vertexLng, vertexLat]);
    }

    // Close the polygon by adding the first vertex at the end
    vertices.push(vertices[0]);

    return vertices;
  }

  zoomOnSelectedPlace(event) {
    let latLng: LatLng = {
      lat: event.location.coordinates[1],
      lng: event.location.coordinates[0],
    };
    //set zoom
    const target = {
      center: latLng,
      zoom: 17,
      bearing: 0,
      pitch: 0,
    };

    //fly to selected location
    this.map.flyTo({
      ...target,
      duration: 2500,
      essential: true,
    });
  }

  //#endregion

  unSubs() {
    this.onDestroy$.next();
  }

  ngOnDestroy() {
    this.#mapPlacesGridService.layers = [];
    this.unSubs();
    this.onDestroy$.complete();
  }

  emitExpandCollapseMap(type) {
    switch (type) {
      case 'collapse':
        this.isExpandMap = false;
        this.output_expandMap.emit(false);
        break;
      case 'expand':
        this.isExpandMap = true;
        this.output_expandMap.emit(true);
        break;
    }

    const timeout = setTimeout(() => {
      this.map.resize();

      clearTimeout(timeout);
    }, 100);
  }
}


